const pushDataLayer = (event: string, data: { method: string }): void => {
  const dataLayer: Array<any> = (window as any).dataLayer || [];
  dataLayer.push({ event, ...data });
};

export default pushDataLayer;
